"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendOccupationReportReminderApiResponseSchema = exports.sendOccupationReportReminderApiPayloadSchema = void 0;
const zod_1 = require("zod");
exports.sendOccupationReportReminderApiPayloadSchema = zod_1.z.object({
    officeId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
});
exports.sendOccupationReportReminderApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
